import styled from 'styled-components/native';
import { FlatList } from 'react-native';

export const TestFlatList = styled(FlatList as new () => FlatList)`
  width: 100%;
  height: 100%;
  padding-horizontal: 1%;
`;
